import React, { useEffect, useRef, useState } from 'react';

import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { fromLonLat, transform } from 'ol/proj';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Feature } from 'ol';
import { Point, Polygon } from 'ol/geom';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import { Icon, Style, Stroke, Text } from 'ol/style';
import XYZ from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS';
import { FullScreen, ScaleLine, ZoomToExtent, defaults as defaultControls } from 'ol/control';
import Zoom from 'ol/control/Zoom';
import axios from "axios";
import { Overlay } from 'ol';
import terrains from '../../assets/images/terrain_map_img.png'
import setelites from '../../assets/images/satellite_map_img.png'
import whitebg from '../../assets/images/white_bg.png'
import openstreet from '../../assets/images/open_street_map_img.png'
import layersicon from '../../assets/images/layers_icon.svg'
import { handleMarkerClickCotton } from './handleMarkerClickCotton';
import KML from 'ol/format/KML';
import { MultiSelect } from "react-multi-select-component";
import { Link } from "react-router-dom";
import Cluster from 'ol/source/Cluster';


export const displaySchemeMapDetails = (responseArray, markerStyle, selectedValue, layers) => {
       
    let source;
     if (selectedValue === '15') {
        // Convert response array to OpenLayers Features
        const features = responseArray.map((item) => {
            const longitude = parseFloat(item.longitude);
            const latitude = parseFloat(item.latitude);
            if (!isNaN(longitude) && !isNaN(latitude)) {
                const feature = new Feature({
                    geometry: new Point(fromLonLat([longitude, latitude])),
                    ...item, // Attach item properties to the feature
                });
                return feature;
            }
            return null;
        }).filter(Boolean); // Remove any null entries

        // Create a source and cluster it
        source = new VectorSource({
            features: features,
        });

        const clusterSource = new Cluster({
            distance: 40, // Cluster distance (adjust as needed)
            source: source,
        });

        // Cluster style
       const clusterStyle = (feature) => {
    const features = feature.get('features');
    const totalValue = features.reduce((sum, f) => sum + parseFloat(f.get('total') || 0), 0); // Aggregate the total values

    return new Style({
        image: new Circle({
            radius: 30, // Fixed circle size
            fill: new Fill({
                color: 'rgba(0, 0, 139, 1)', // Dark blue color
            }),
        }),
        text: new Text({
            text: totalValue.toString(), // Display the aggregated total value
            fill: new Fill({
                color: '#fff', // White color for text
            }),
            font: '12px sans-serif',
            textAlign: 'center',
        }),
    });
};



        const clusterLayer = new VectorLayer({
            source: clusterSource,
            style: clusterStyle,
        });

        layers.push(clusterLayer);
    }else{
        console.log("responseArray-----",responseArray)
      
         if (!Array.isArray(responseArray)) {
            console.error("responseArray is not an array:", responseArray);
            return; // Exit if responseArray is invalid
        }

        const vectorLayer = new VectorLayer({
        source: new VectorSource({
            features: responseArray.flatMap((plot) => {
                    const features = [];

                    // Handle polygons and calculate marker location
                    //let polygonShape = null;


                  
                     const polygonShape =
                        plot.project_Geo_Fencing ||
                        plot.polygonshape ||
                        plot.geo_Tagging ||
                        plot.geoPlotting ||
                        plot.polygonData ||
                        plot.land_coordinate ||
                        plot.projectSurveyPolygonList?.[0]?.polygonShape ||
                        plot.farmerCropSurveyPolygonList?.[0]?.polygonshape ||
                        plot.farmerCropSurveyPolygonList?.[0]?.polygonShape ||
                        plot.farmerCropSurveryPolygon?.[0]?.polygonShape ||
                        plot.farmerLandDetailsModel?.[0]?.polygonData||
                        plot.surveyPolygonList?.[0]?.polygonShape;



                    let longitude = null;
                    let latitude = null;

                    if (selectedValue == '25') {

                            const geoTagging = polygonShape;

                            if (Array.isArray(geoTagging) && geoTagging.length > 0) {
                                const polygonCoordinates = [];
                                let singlePointFeature;

                                // Process the geo_Tagging array to create polygon and single point
                                geoTagging.forEach((coordinate, index) => {
                                    if (Array.isArray(coordinate) && coordinate.length >= 2) {
                                        const [lng, lat] = coordinate;

                                        // Add coordinates to the polygon array
                                        polygonCoordinates.push(fromLonLat([lng, lat]));

                                        // Use the first coordinate to create a single point feature
                                        if (index === 0) {
                                            singlePointFeature = new Feature({
                                                geometry: new Point(fromLonLat([lng, lat])),
                                            });
                                            singlePointFeature.setProperties(plot); // Attach plot properties
                                        }
                                    } else {
                                        console.error("Invalid coordinate format", coordinate);
                                    }
                                });
     
                                if (polygonCoordinates.length > 0) {
                                    polygonCoordinates.push(polygonCoordinates[0]); // Close the polygon

                                    // Create the polygon feature
                                    const polygonFeature = new Feature({
                                        geometry: new Polygon([polygonCoordinates]),
                                    });
                                    polygonFeature.setProperties(plot); // Attach plot properties

                                    // Apply styles to polygon
                                    polygonFeature.setStyle(
                                        new Style({
                                            stroke: new Stroke({
                                                color: '#ff0000', // Red border
                                                width: 2,
                                            }),
                                            fill: new Fill({
                                                color: 'rgba(255, 0, 0, 0)', // Semi-transparent fill
                                            }),
                                        })
                                    );

                                    // Apply styles to the point
                                    singlePointFeature.setStyle(
                                        new Style({
                                            image: new Icon({
                                                src: markerStyle, // Marker icon
                                                scale: 1.0,
                                            }),
                                        })
                                    );

                                    // Return both the polygon and the single point
                                    return [polygonFeature, singlePointFeature];
                                }
                                } else {
                                    console.error("geo_Tagging is empty or invalid:", geoTagging);
                                }
                        }


                     
                    console.log("polygonShape",polygonShape);
                       

                    if (polygonShape && typeof polygonShape === 'string') {
                        try {
                            const parsedCoordinates = JSON.parse(polygonShape);
                            const polygonCoordinates = parsedCoordinates.map((coord) =>
                                fromLonLat([coord.lng||coord.Longitude, coord.lat||coord.Latitude])
                            );

                            console.log("polygonCoordinates",polygonCoordinates);

                            if (polygonCoordinates.length > 0) {
                                polygonCoordinates.push(polygonCoordinates[0]); // Ensure polygon is closed
                            }

                            const polygonFeature = new Feature({
                                geometry: new Polygon([polygonCoordinates]),
                            });
                            polygonFeature.setProperties(plot);
                            features.push(polygonFeature);

                            // Calculate centroid for the marker
                            console.log("+++++++++++++++++++++++",parsedCoordinates);
                            const centroid = calculateCentroid(parsedCoordinates);
                            console.log("+++++++++++++++++++++++centroid",centroid);
                            if (centroid) {
                                longitude = centroid.lng || centroid.Longitude;
                                latitude = centroid.lat || centroid.Latitude ;
                            } 
                        } catch (error) {
                            console.error("Error parsing polygon coordinates:", error, polygonShape);
                        }
                    } else if (selectedValue === '2') {
                        console.log("+++++++++++++++++++++++",plot.latitude);
                        const lat = plot.farmerCropSurveyImageList[0]?.surveyorLat;
                        const lng = plot.farmerCropSurveyImageList[0]?.surveyorLong;
                        longitude = lng;
                        latitude = lat;
                    } else {
                        longitude =
                            plot.surveyorLong ||
                            plot.longitude ||
                            plot.coordinateslogitude ||
                            plot.farmerCropSurveyPolygonList?.[0]?.surveyorLat ||
                            plot.longitudeCoordinate ||
                            plot.coordinateslogitude ||
                            plot.polygonshape?.[0]?.surveyorLong;
                        latitude =
                            plot.surveyorLat ||
                            plot.latitude ||
                            plot.coordinatesLatitude ||
                            plot.latitudeCoordinate ||
                            plot.farmerCropSurveyPolygonList?.[0]?.surveyorLat ||
                            plot.farmerLandDetailsModel ||
                            plot.coordinatesLatitude ||
                            plot.polygonshape?.[0]?.surveyorLat;
                    }
                        console.log("_____________________________________",latitude);
                        console.log("_____________________________________",longitude);

                    if (longitude && latitude) {
                        const pointFeature = new Feature({
                            geometry: new Point(fromLonLat([longitude, latitude])),
                        });
                        pointFeature.setProperties(plot);
                        features.push(pointFeature);
                    }
                    console.log("features-------------",features)
                    return features;
                }),
        }),
        style: new Style({
            image: new Icon({
                src: markerStyle, // Marker icon URL for points
                scale: 1.0,
            }),
            fill: new Fill({
                color: 'rgba(255, 0, 0, 0.2)', // Polygon fill color with transparency
            }),
            stroke: new Stroke({
                color: '#ff0000', // Polygon border color
                width: 2,
            }),
        }),
    });

    layers.push(vectorLayer);
    }
    

};

/**
 * Calculate the centroid of a polygon.
 * @param {Array} coordinates - Array of coordinates in the format [{ lat: number, lng: number }].
 * @returns {Object} - The centroid as { lat: number, lng: number } or null if invalid.
 */
const calculateCentroid = (coordinates) => {
    if (!Array.isArray(coordinates) || coordinates.length === 0) {
        return null;
    }

    let centroidLat = 0;
    let centroidLng = 0;

    console.log("Input Coordinates:", coordinates);

    coordinates.forEach((coord) => {
        // Convert Latitude and Longitude to numbers before adding
        centroidLat += parseFloat(coord.lat || coord.Latitude);
        centroidLng += parseFloat(coord.lng || coord.Longitude);
    });

    const totalPoints = coordinates.length;
    const a = {
        lat: centroidLat / totalPoints,
        lng: centroidLng / totalPoints,
    };

    console.log("Centroid Coordinates:", a);

    return a;
};

